if ($('.id-1').length) {

  $('.homepage-blog-wrapper .news-item').wrapAll('<div class="blog-slick"></div>');

  $('.homepage-blog-wrapper .blog-slick').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: false,
    dots: false,
    arrows: true,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  });
}